import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';

import { ListarModelosVistoriaComponent } from './components/listar-modelos-vistoria.component';
import { ListarModelosVistoriaResolver } from './listar-modelos-vistoria.resolver';

@NgModule({
  declarations: [
    ListarModelosVistoriaComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  providers: [
    ListarModelosVistoriaResolver,
  ],
})
export class ListarModelosVistoriaModule { }
